<!-- Spacer -->
<div
    class="zuper-vertical-navigation-item-wrapper"
    [ngClass]="item.classes?.wrapper"></div>
